import { FormattedMessage } from 'react-intl';
import style from './style.module.less';
import messages from './messages';

export const ShippingStrategyDefaultTag = () => {
  return (
    <div className={style['strategy-default-tag']}>
      <FormattedMessage {...messages.shipstationDefaultText} />
    </div>
  );
};
